import type { PropsWithChildren } from 'react';
import { Box } from '@mui/material';

const auditManualSx = {
  marginTop: '40px',
  '& table': {
    marginTop: '10px',
  },
  '& tr, & td': {
    border: '1px solid',
    borderColor: 'border.default',
  },
  '& td': {
    padding: '8px',
  },
} as const;

const AuditManualLayout = ({ children }: PropsWithChildren) => <Box sx={auditManualSx}>{children}</Box>;

export default AuditManualLayout;
